import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import BrandIntroSection from './components/BrandIntroSection';
import BrandValuesSection from './components/BrandValuesSection';
import PublishingDirectionsSection from './components/PublishingDirectionsSection';
import NewBooks2026Section from './components/NewBooks2026Section';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <BrandIntroSection />
        <BrandValuesSection />
        <PublishingDirectionsSection />
        <NewBooks2026Section />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}